// extracted by mini-css-extract-plugin
export default {"label":"switch_label__RfKNv","checkmark":"switch_checkmark__+YE9S"};